import React from 'react';
import { useNavigate } from "react-router-dom";

//3rd party
import * as Icon from 'react-bootstrap-icons';

//Styles
import '../css/bottom-menu.css';

// i18n
import { useTranslations } from '../context/TranslationsContext';

const BottomMenu = () => {
    const { t, loading: i18nLoading } = useTranslations();

    const navigate = useNavigate();
    const functie_id = localStorage.getItem('functie_id');

    const currentLang = String(localStorage.getItem('langId') || localStorage.getItem('lang_id') || '1');

    const setLang = (langNumericId) => {
        // bewaar in beide keys voor compatibiliteit
        localStorage.setItem('langId', String(langNumericId));
        localStorage.setItem('lang_id', String(langNumericId));
        // herlaad zodat TranslationsProvider opnieuw mount met juiste langId
        window.location.reload();
    };

    //Logout function
    const logout = () => {
        localStorage.removeItem("bearerToken");
        localStorage.removeItem("ingelogd");
        localStorage.removeItem("formdata");
        navigate("/login");
    }

    return(
        <div className="bottom-nav">
            <div className="nav-item" onClick={() => navigate("/")}>
                <Icon.ClockHistory />
                <p>{t('day_state', 'Day state')}</p>
            </div>
            <div className="nav-item" onClick={() => navigate("/verlof")}>
                <Icon.Receipt />
                <p>{t('leave_of_absence', 'Leave of absence')}</p>
            </div>
            { functie_id == 3 || functie_id == 4 || functie_id == 6 ? //Voorman, Directie, voorman tekenkamer
                <div className="nav-item" onClick={() => navigate("/verlof/review")}>
                    <Icon.Receipt />
                    <p>{t('review_leave_requests', 'Review leave requests')}</p>
                </div>
                : null
            }
            { functie_id == 3 || functie_id == 4 || functie_id == 6 ? //Voorman, Directie, voorman tekenkamer
                <div className="nav-item" onClick={() => navigate("/hours/review")}>
                    <Icon.ClockHistory />
                    <p>{t('review_hours', 'Review hours')}</p>
                </div>
                : null
            }
            <div className="nav-item" onClick={logout}>
                <Icon.BoxArrowInRight />
                <p>{t('logout', 'Logout')}</p>
            </div>
        </div>
        
    );
}

export default BottomMenu;